import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';

@UntilDestroy()
@Component({
  selector: 'app-accept-token',
  templateUrl: './accept-token.component.html',
  styleUrls: ['./accept-token.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcceptTokenComponent extends ComponentAbstract implements OnInit, OnDestroy {
  constructor(
    protected cdr: ChangeDetectorRef,
    private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.oidcSecurityService
      .checkAuth()
      .pipe(take(1))
      .subscribe(() => {
        this.oidcSecurityService.getAuthenticationResult().subscribe(result => {
          //as oidcSecurityService can not work with '&' it was replaced by '??' so we should do reverse replacement
          const navigateRoute: string = result?.state?.replace(/\?\?/g, '&');
          if (!navigateRoute) {
            this.router.navigateByUrl('/login');
            return;
          }

          const paramsStartAt = navigateRoute.indexOf('?');
          if (paramsStartAt === -1) {
            this.router.navigate([navigateRoute]);
            return;
          }

          const url = navigateRoute.substring(0, paramsStartAt);
          const params = navigateRoute
            .substring(paramsStartAt + 1)
            .split('&')
            .reduce((params: { [paramKey: string]: string }, param) => {
              const paramPair = param.split('=');
              params[paramPair[0]] = paramPair[1];
              return params;
            }, {});
          this.router.navigate([url], { queryParams: params });
        });
      });
  }

  ngOnDestroy(): void {}
}
